import Vue from 'vue'
import Router from 'vue-router'
import VueClazyLoad from 'vue-clazy-load' // ES6 (Babel and others)
import store from './store'

import NProgress from 'nprogress'

import Login from './views/Auth/Login.vue'

Vue.use(Router)
Vue.use(VueClazyLoad)

const ifNotAuthenticated = (to, from, next) => {
    if (!store.getters.isAuthenticated) {
        next()
        return
    }
    next('/')
}

const ifAuthenticated = (to, from, next) => {
    var self = this
    store.dispatch('showError', 'false')
    if (store.getters.isAuthenticated) {
        if (store.getters.authUser == '' || store.getters.authUser == null) {
            Vue.prototype.$http.get('/auth/profile')
                .then(function(response) {
                    store.dispatch('updateUser', response.data)
                    store.dispatch('updateOpenSessions', response.data.open_sessions)
                    store.dispatch('updateClientVariables', response.data.variables)
                        // document.location.reload()
                    next()
                })
                .catch(function(error) {
                    localStorage.removeItem('token')
                    store.dispatch('logoutUser')
                    next('/login')
                })
        }
        next()
        return
    }
    next('/login')
}

function isAdminRole(i) {
    return i == 'admin' || i == 'superadmin'
}

const ifAdmin = (to, from, next) => {
    var roles = store.getters.authRoles
    let result = roles.find(isAdminRole)

    if (result) {
        next()
        return
    }
    next('/')
}

function multiple(guards) {
    return (to, from, next) => {
        const stack = [].concat(guards)

        function another() {
            const guard = stack.pop()
            guard ? guard(to, from, another) : next()
        }
        another()
    }
}

const router = new Router({
    routes: [{
            path: '/login',
            name: 'auth-login',
            component: Login,
            beforeEnter: ifNotAuthenticated
        },
        {
            path: '/reset',
            name: 'auth-reset',
            component: Login,
            props: { 'formModeProp': 'reset' }
        },
        {
            path: '/billing/dashboard',
            name: 'billing-dashboard',
            component: () =>
                import ( /* webpackChunkName: "home" */ './views/Billing/ViewDashboard.vue'),
            beforeEnter: ifAuthenticated
        },
        {
            path: '/billing/statements',
            name: 'billing-statement',
            component: () =>
                import ( /* webpackChunkName: "home" */ './views/Billing/StatementList.vue'),
            beforeEnter: ifAuthenticated
        },
        {
            path: '/',
            name: 'reportdesk-reports-worklist',
            component: () =>
                import ( /* webpackChunkName: "photodesk" */ './views/Dashboard/ViewDashboardNew.vue'),
            beforeEnter: ifAuthenticated
        },
        {
            path: '/dashboard',
            name: 'dashboard',
            component: () =>
                import ( /* webpackChunkName: "dashboard" */ './views/Dashboard/ViewDashboardSample.vue'),
            beforeEnter: ifAuthenticated
        },
        {
            path: '/dashboard/sample',
            name: 'dashboard-sample',
            component: () =>
                import ( /* webpackChunkName: "dashboard" */ './views/Dashboard/ViewDashboardSample.vue'),
            beforeEnter: ifAuthenticated
        },
        {
            path: '/projectdesk/projects',
            name: 'projectdesk-projects-list',
            component: () =>
                import ( /* webpackChunkName: "photodesk" */ './views/ProjectDesk/ProjectList.vue'),
            beforeEnter: ifAuthenticated
        },
        {
            path: '/projectdesk/projects/:id_project',
            name: 'projectdesk-projects-view',
            component: () =>
                import ( /* webpackChunkName: "photodesk" */ './views/ProjectDesk/ViewProject.vue'),
            beforeEnter: ifAuthenticated,
            props: true
        },
        {
            path: '/projectdesk/project/add',
            name: 'projectdesk-project-add',
            component: () =>
                import ( /* webpackChunkName: "photodesk" */ './views/ProjectDesk/AddProject.vue'),
            beforeEnter: ifAuthenticated
        },

        {
            path: '/photodesk/sessions',
            name: 'photodesk-sessions-list',
            component: () =>
                import ( /* webpackChunkName: "photodesk" */ './views/PhotoDesk/SessionList.vue'),
            beforeEnter: ifAuthenticated
        },
        {
            path: '/photodesk/sessions/:id_session',
            name: 'photodesk-sessions-view',
            component: () =>
                import ( /* webpackChunkName: "photodesk" */ './views/PhotoDesk/ViewSession.vue'),
            beforeEnter: ifAuthenticated,
            props: true
        },
        {
            path: '/photodesk/session/add',
            name: 'photodesk-session-add',
            component: () =>
                import ( /* webpackChunkName: "photodesk" */ './views/PhotoDesk/AddSession.vue'),
            beforeEnter: ifAuthenticated
        },
        {
            path: '/photodesk/models',
            name: 'photodesk-models-list',
            component: () =>
                import ( /* webpackChunkName: "photodesk" */ './views/PhotoDesk/ModelList.vue'),
            beforeEnter: ifAuthenticated
        },
        {
            path: '/photodesk/sessions/:id_session/add',
            name: 'photodesk-sessions-add-products',
            component: () =>
                import ( /* webpackChunkName: "photodesk" */ './views/PhotoDesk/AddProducts.vue'),
            beforeEnter: ifAuthenticated,
            props: true
        },

        {
            path: '/photodesk/sessions/:id_session/import',
            name: 'photodesk-sessions-import-products',
            component: () =>
                import ( /* webpackChunkName: "photodesk" */ './views/PhotoDesk/ImportProducts.vue'),
            beforeEnter: ifAuthenticated,
            props: true
        },
        {
            path: '/pretouchdesk/sessions',
            name: 'pretouchdesk-sessions-list',
            component: () =>
                import ( /* webpackChunkName: "photodesk" */ './views/PretouchDesk/SessionList.vue'),
            beforeEnter: ifAuthenticated
        },
        {
            path: '/pretouchdesk/sessions/:id_session',
            name: 'pretouchdesk-sessions-view',
            component: () =>
                import ( /* webpackChunkName: "photodesk" */ './views/PretouchDesk/ViewSession.vue'),
            beforeEnter: ifAuthenticated,
            props: true
        },
        {
            path: '/pretouchdesk/sessions/:id_session/add',
            name: 'pretouchdesk-sessions-add-products',
            component: () =>
                import ( /* webpackChunkName: "photodesk" */ './views/PretouchDesk/AddProducts.vue'),
            beforeEnter: ifAuthenticated,
            props: true
        },
        {
            path: '/retouchdesk/sessions',
            name: 'retouchdesk-sessions-list',
            component: () =>
                import ( /* webpackChunkName: "photodesk" */ './views/RetouchDesk/SessionList.vue'),
            beforeEnter: ifAuthenticated
        },
        {
            path: '/retouchdesk/sessions/:id_session',
            name: 'retouchdesk-sessions-view',
            component: () =>
                import ( /* webpackChunkName: "photodesk" */ './views/RetouchDesk/ViewSession.vue'),
            beforeEnter: ifAuthenticated,
            props: true
        },
        {
            path: '/retouchdesk/sessions/:id_session/add',
            name: 'retouchdesk-sessions-add-products',
            component: () =>
                import ( /* webpackChunkName: "photodesk" */ './views/RetouchDesk/AddProducts.vue'),
            beforeEnter: ifAuthenticated,
            props: true
        },
        {
            path: '/copydesk/session/add',
            name: 'copydesk-session-add',
            component: () =>
                import ( /* webpackChunkName: "photodesk" */ './views/CopyDesk/AddSession.vue'),
            beforeEnter: ifAuthenticated
        },
        {
            path: '/copydesk/templates',
            name: 'copydesk-templates-list',
            component: () =>
                import ( /* webpackChunkName: "copydesk" */ './views/CopyDesk/TemplateList.vue')
        },
        {
            path: '/copydesk/template/add',
            name: 'copydesk-template-add-template',
            component: () =>
                import ( /* webpackChunkName: "copydesk" */ './views/CopyDesk/Template/AddTemplate.vue'),
            beforeEnter: ifAuthenticated
        },
        {
            path: '/copydesk/template/:id_copydesk_template',
            name: 'copydesk-templates-view',
            component: () =>
                import ( /* webpackChunkName: "copydesk" */ './views/CopyDesk/Template/ViewTemplate.vue'),
            props: true
        },
        {
            path: '/copydesk/imports',
            name: 'copydesk-imports-list',
            component: () =>
                import ( /* webpackChunkName: "copydesk" */ './views/CopyDesk/ImportList.vue')
        },
        {
            path: '/copydesk/imports/add',
            name: 'copydesk-imports-list',
            component: () =>
                import ( /* webpackChunkName: "copydesk" */ './views/CopyDesk/Imports/AddImport.vue')
        },
        {
            path: '/copydesk/sessions/:type',
            name: 'copydesk-sessions-list',
            component: () =>
                import ( /* webpackChunkName: "copydesk" */ './views/CopyDesk/SessionList.vue'),
            props: true
        },
        {
            path: '/copydesk/sessions/write/:id_session',
            name: 'copydesk-sessions-view-write',
            component: () =>
                import ( /* webpackChunkName: "photodesk" */ './views/CopyDesk/ViewSession.vue'),
            beforeEnter: ifAuthenticated,
            props: true
        },
        {
            path: '/copydesk/sessions/review/:id_session',
            name: 'copydesk-sessions-view-review',
            component: () =>
                import ( /* webpackChunkName: "photodesk" */ './views/CopyDesk/ViewSession.vue'),
            beforeEnter: ifAuthenticated,
            props: true
        },
        {
            path: '/copydesk/sessions/write/:id_session/add',
            name: 'copydesk-sessions-write-add-products',
            component: () =>
                import ( /* webpackChunkName: "photodesk" */ './views/CopyDesk/Write/AddProducts.vue'),
            beforeEnter: ifAuthenticated,
            props: true
        },

        {
            path: '/copydesk/sessions/review/:id_session/add',
            name: 'copydesk-sessions-review-add-products',
            component: () =>
                import ( /* webpackChunkName: "photodesk" */ './views/CopyDesk/Review/AddProducts.vue'),
            beforeEnter: ifAuthenticated,
            props: true
        },
        {
            path: '/copydesk/sessions/review/:id_session/addnew',
            name: 'copydesk-sessions-review-add-products',
            component: () =>
                import ( /* webpackChunkName: "photodesk" */ './views/CopyDesk/Review/AddProductsNew.vue'),
            beforeEnter: ifAuthenticated,
            props: true
        },

        {
            path: '/reportdesk/reports/worklist',
            name: 'reportdesk-reports-worklist',
            component: () =>
                import ( /* webpackChunkName: "photodesk" */ './views/ReportDesk/ReportDeskWorklist.vue'),
            beforeEnter: ifAuthenticated
        },
        {
            path: '/reportdesk/reports/grid',
            name: 'reportdesk-reports-grid',
            component: () =>
                import ( /* webpackChunkName: "photodesk" */ './views/ReportDesk/ReportDeskGrid.vue'),
            beforeEnter: ifAuthenticated
        },
        {
            path: '/reportdesk/reports/contactsheet',
            name: 'reportdesk-reports-contactsheet',
            component: () =>
                import ( /* webpackChunkName: "photodesk" */ './views/ReportDesk/ContactSheet.vue'),
            beforeEnter: ifAuthenticated
        },
        {
            path: '/reportdesk/reports/exported',
            name: 'reportdesk-reports-exported',
            component: () =>
                import ( /* webpackChunkName: "photodesk" */ './views/ReportDesk/ReportDeskExportedReports.vue'),
            beforeEnter: ifAuthenticated
        },
        {
            path: '/productdesk/products',
            name: 'productdesk-products',
            component: () =>
                import ( /* webpackChunkName: "photodesk" */ './views/ProductDesk/ProductList.vue'),
            beforeEnter: ifAuthenticated
        },
        {
            path: '/productdesk/inventory',
            name: 'productdesk-inventory',
            component: () =>
                import ( /* webpackChunkName: "photodesk" */ './views/ProductDesk/Inventory.vue'),
            beforeEnter: ifAuthenticated
        },
        {
            path: '/productdesk/product/:id_product',
            name: 'productdesk-product-view',
            component: () =>
                import ( /* webpackChunkName: "photodesk" */ './views/ProductDesk/ViewProduct.vue'),
            beforeEnter: ifAuthenticated,
            props: true
        },

        {
            path: '/orgdesk/settings',
            name: 'orgdesk-settings',
            component: () =>
                import ( /* webpackChunkName: "photodesk" */ './views/OrgDesk/Settings/ViewSettings.vue'),
            beforeEnter: ifAuthenticated
        },

        {
            path: '/impexdesk/imports',
            name: 'impexdesk-imports',
            component: () =>
                import ( /* webpackChunkName: "photodesk" */ './views/ImpexDesk/Imports.vue'),
            beforeEnter: ifAuthenticated
        },

        {
            path: '/impexdesk/exports',
            name: 'impexdesk-exports',
            component: () =>
                import ( /* webpackChunkName: "photodesk" */ './views/ImpexDesk/Exports.vue'),
            beforeEnter: ifAuthenticated
        }
    ]
})

export default router